// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__12f0T","grid":"styles_grid__rlTfD"};